"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExplainRpc = void 0;
var ExplainRpc;
(function (ExplainRpc) {
    ExplainRpc.ExplainFunctionName = 'explain';
    ExplainRpc.ExplainStatusFunctionName = 'explain.status';
    let Step;
    (function (Step) {
        Step["NEW"] = "new";
        Step["RUNNING"] = "running";
        Step["SEARCH_APPMAPS"] = "search-appmaps";
        Step["COLLECT_CONTEXT"] = "collect-context";
        Step["EXPLAIN"] = "explain";
        Step["COMPLETE"] = "complete";
        Step["ERROR"] = "error";
    })(Step = ExplainRpc.Step || (ExplainRpc.Step = {}));
})(ExplainRpc || (exports.ExplainRpc = ExplainRpc = {}));
